export function autoplayVoiceoverUrl(url, audioElement) {
    if (!url) return;

    const startPlayback = (el) => {
        try {
            el.currentTime = 0;
            const playPromise = el.play();
            if (playPromise?.catch) playPromise.catch(() => {});
        } catch (_) {}
    };

    if (audioElement) {
        const tryPlay = () => startPlayback(audioElement);
        if (audioElement.readyState >= 2 && audioElement.src) {
            tryPlay();
        } else {
            audioElement.addEventListener('canplay', tryPlay, { once: true });
            try {
                audioElement.load?.();
            } catch (_) {}
        }
        return;
    }

    const audio = new Audio(url);
    audio.addEventListener('canplay', () => startPlayback(audio), { once: true });
    audio.load();
}
